module.exports = __webpack_public_path__ + "img/color@2x.1aec2d3.jpg";